import { render, staticRenderFns } from "./ChangeLogModal.vue?vue&type=template&id=7d85e5c3&scoped=true&"
import script from "./ChangeLogModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLogModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogModal.vue?vue&type=style&index=0&id=7d85e5c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85e5c3",
  null
  
)

export default component.exports